import styled from 'styled-components';

export const TitleComponent = styled.div`
  margin-bottom: 2px;
  color: ${({ theme }) => theme.colors.greys.adminGreyDark};
  font: 400 14px/22px ${({ theme }) => theme.fonts.join()};
`;
